const UTF8_BOM = '﻿';

/**
 * Igual ao `downloadCSV`, mas via Blob em vez de `data:` URI. Necessário para
 * relatórios grandes: `encodeURIComponent` infla acentos e separadores em 3x e
 * um `data:` URI muito longo faz o download falhar em silêncio no navegador.
 *
 * O backend envia o BOM, mas o XHR o descarta ao decodificar a resposta como
 * texto — sem ele o Excel abre o arquivo como ANSI e quebra os acentos.
 */
export const downloadCSVBlob = (content: string, filename: string) => {
    const doc = document.body;

    if (doc === null) {
        return;
    }

    const withBom = content.startsWith(UTF8_BOM)
        ? content
        : UTF8_BOM + content;
    const blob = new Blob([withBom], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link: HTMLAnchorElement = document.createElement('a');

    link.setAttribute('href', url);
    link.setAttribute('download', filename);

    doc.appendChild(link);
    link.click();
    doc.removeChild(link);
    URL.revokeObjectURL(url);
};

export const downloadCSV = (content: string, filename: string) => {
    const encodedUri: string = encodeURIComponent(content);
    const link: HTMLAnchorElement = document.createElement('a');
    link.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,%EF%BB%BF' + encodedUri
    );
    const doc = document.body;

    if (doc === null) {
        return;
    }

    if (filename) {
        link.setAttribute('download', filename);
    }

    doc.appendChild(link);
    link.click();
    doc.removeChild(link);
};
